import PropTypes from 'prop-types';
import { propOr, length, isEmpty } from 'ramda';
import classNames from 'classnames';

import MapNoteHeader from './MapNoteHeader.jsx';
import MapNoteChangesButtons from './MapNoteChangesButtons.jsx';
import MapNoteSubject from './MapNoteSubject.jsx';
import MapNoteTypeDropdown from './MapNoteTypeDropdown.jsx';
import s from './MapNoteSheetEditable.module.scss';
import Spinner from '../spinner/Spinner.jsx';

const MapNoteSheetEditable = props => {
    const { mapNote, updatedFields, userEmail, onClose, onTrash, onSave, onCancel, onSubjectChange, onTypeChange, loading } = props;
    const subject = propOr(mapNote.subject, 'subject', updatedFields);
    const noteType = propOr(mapNote.noteType, 'noteType', updatedFields);
    return (
        <div className={s.mapNoteSheetContainer}>
            <div className={s.mapNoteSheet}>
                <MapNoteHeader userEmail={userEmail} mapNote={mapNote} onClose={onClose} onTrash={onTrash} />
                <MapNoteChangesButtons isEnabled={length(subject) > 0 && !isEmpty(updatedFields)} onSave={onSave} onCancel={onCancel} />
                <MapNoteSubject onTextChange={onSubjectChange} text={subject} placeholder="Note Name" />
                <MapNoteTypeDropdown selected={noteType} onOptionClick={onTypeChange} />
            </div>
            <div className={classNames({ [s.loading]: loading })}>
                <Spinner loading={loading} />
            </div>
        </div>
    );
};

MapNoteSheetEditable.propTypes = {
    loading: PropTypes.bool.isRequired,
    userEmail: PropTypes.string.isRequired,
    mapNote: PropTypes.object.isRequired,
    updatedFields: PropTypes.object.isRequired,
    onSubjectChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onTrash: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default MapNoteSheetEditable;
